module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "swipe-demo",
    attrs: {
      "title": "Swipe"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Swipe', _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "loop": false
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "index",
      "description": "下标",
      "code": _vm.index_code
    },
    slot: "left"
  }, [_c('p', [_vm._v("当前下标是 " + _vm._s(_vm.index))]), _vm._v(" "), _c('Swipe', {
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("当前下标是 " + _vm._s(_vm.trigger_index))]), _vm._v(" "), _c('Swipe', {
    attrs: {
      "trigger": 'progress'
    },
    model: {
      value: (_vm.trigger_index),
      callback: function($$v) {
        _vm.trigger_index = $$v
      },
      expression: "trigger_index"
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("滑动过程中改变index")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "index": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("显示index")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "index": true,
      "index_trigger": 'hover'
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("index hover触发滑动")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "index": true,
      "index_x_offset": 15,
      "index_y_offset": -10
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("调整下标偏差")])])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "arrow",
      "description": "箭头",
      "code": _vm.arrow_code
    },
    slot: "right"
  }, [_c('Swipe', _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("默认hover显示左右箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("总是显示箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": false
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("无箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": true,
      "outer_arrow": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("外部箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": true,
      "outer_arrow": true,
      "arrow_offset": -15
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("调整箭头偏差")])])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "custom slide",
      "description": "自定义滑动",
      "code": _vm.sliding_code
    },
    slot: "left"
  }, [_c('p', [_vm._v("同时展示多个Slide")]), _vm._v(" "), _c('Swipe', {
    attrs: {
      "preview": 2,
      "between": 12
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "preview": 3,
      "between": 12
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('p', [_vm._v("多个Slide同时滑动")]), _vm._v(" "), _c('Swipe', {
    attrs: {
      "preview": 2,
      "between": 12,
      "sliding_num": 2
    }
  }, _vm._l((6), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "coverflow",
      "description": "coverflow过渡",
      "code": _vm.coverflow_code
    },
    slot: "right"
  }, [_c('Swipe', {
    attrs: {
      "coverflow": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "coverflow": true,
      "preview": 2
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "coverflow": true,
      "preview": 3
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "free",
      "description": "自由滑动",
      "code": _vm.free_code
    },
    slot: "right"
  }, [_c('Swipe', _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "free": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "event",
      "description": "事件",
      "code": _vm.event_code
    },
    slot: "right"
  }, [_c('Swipe', {
    ref: "swiper"
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.swiper.$emit('slide-prev')
      }
    }
  }, [_vm._v("前一个")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.swiper.$emit('slide-next')
      }
    }
  }, [_vm._v("后一个")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.swiper.$emit('slide-to', 1)
      }
    }
  }, [_vm._v("到第二个")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5e102d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Swipe.vue
// module id = 688
// module chunks = 0